import { createDisplayedLabels } from '../../../utils/labels';
import { getItemsPopulatedModifierGroups } from '../../../utils/modifierGroups';
import { createDisplayedPriceVariants } from '../../../utils/priceVariants';
import { isEmpty } from '../../../utils/common';
import { orderSettingsAdapter } from '../../../utils/adapters';
import { DEFAULT_PRICE } from '../../../utils/item';
export const buildPopulatedItem = (item, labelsMap, priceVariantsMap, populatedModifierGroupsMap) => {
  var _item$priceVariants, _item$priceVariants2;
  const hasPopulatedVariants = ((_item$priceVariants = item.priceVariants) == null ? void 0 : _item$priceVariants.variants) && priceVariantsMap;
  const hasValidPopulatedVariants = hasPopulatedVariants && !isEmpty(priceVariantsMap);
  const populatedPriceVariants = hasValidPopulatedVariants ? createDisplayedPriceVariants(item.priceVariants.variants, priceVariantsMap) : undefined;
  const itemPriceVariants = hasPopulatedVariants ? populatedPriceVariants : (_item$priceVariants2 = item.priceVariants) == null || (_item$priceVariants2 = _item$priceVariants2.variants) == null ? void 0 : _item$priceVariants2.map(priceVariant => ({
    variantId: priceVariant.variantId,
    priceInfo: priceVariant.priceInfo
  }));
  const itemLabels = item.labels && labelsMap && !isEmpty(labelsMap) ? createDisplayedLabels(item.labels, labelsMap) : item.labels;
  const itemModifierGroups = item.modifierGroups && populatedModifierGroupsMap && !isEmpty(populatedModifierGroupsMap) ? getItemsPopulatedModifierGroups(item.modifierGroups, populatedModifierGroupsMap) : item.modifierGroups;
  const itemOrderSettings = orderSettingsAdapter(item.orderSettings);
  const populatedItem = {
    id: item.id,
    revision: item.revision,
    name: item.name,
    description: item.description,
    ...(item.priceInfo && {
      priceInfo: item.priceInfo
    }),
    ...(itemPriceVariants && {
      priceVariants: {
        variants: itemPriceVariants
      }
    }),
    image: item.image,
    additionalImages: item.additionalImages,
    ...(itemLabels && {
      labels: itemLabels
    }),
    visible: item.visible,
    orderSettings: itemOrderSettings,
    ...(itemModifierGroups && {
      modifierGroups: itemModifierGroups
    }),
    ...(item.businessLocationIds && {
      businessLocationIds: item.businessLocationIds
    }),
    createdDate: item.createdDate
  };

  // if item has variants but they are not valid, default to zero price
  if (!itemPriceVariants && !item.priceInfo) {
    populatedItem.priceInfo = {
      price: DEFAULT_PRICE
    };
  }
  return populatedItem;
};
//# sourceMappingURL=buildPopulatedItem.js.map